module.exports = __webpack_public_path__ + "img/Attachments.b479f9bc.jpg";